import { isJson } from "./json.util";
import { wlLocalStorage } from "./localStorage.util";

export const getHiddenAssistsIds = (): number[] => {
  const hiddenAssists = wlLocalStorage.getItem('hidden_assists');

  return isJson(hiddenAssists)
    ? JSON.parse(String(hiddenAssists))
    : [];
}